<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fmh" id="_idParaDest-1"><a id="_idTextAnchor000"></a><a href="#/text/9780062693457_Contents#r_idParaDest-1"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">Dedication</span></span></a></h2>
<p class="dedi"><i>This one’s for you, Rachael</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062693457_Dedication.vue?9847676e